import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { employeesKeys } from 'src/features/employees/api/query-keys/employees';
import { ApiError } from 'src/types/interfaces/api-error';
import { delayedCallbackExecution } from 'src/utils/delayed-callback-execution';
import { removeEmployeeFromEmployeeGroup } from '../../lib/employees-group-employees';
import { UnassignEmployeeFromEmployeeGroupPayload } from '../../types/payload/unassign-employee-from-employee-group.payload';

export const useRemoveEmployeeFromEmployeeGroup = (onSuccess?: () => void) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: UnassignEmployeeFromEmployeeGroupPayload) =>
      removeEmployeeFromEmployeeGroup(payload),
    onSuccess: () => {
      delayedCallbackExecution(1000, () => {
        queryClient.invalidateQueries({
          queryKey: employeesKeys.details(),
        });
      });
      toast.success(
        t(
          'employeesGroups:employees.removeEmployeesFromGroupDialog.successMessage',
        ),
      );
      onSuccess?.();
    },
    onError: (error: ApiError) => {
      toast.error(
        error?.response?.data?.message ||
          t('common:errorMessages:somethingWentWrong'),
      );
    },
  });
};
